export const CRITERIA_STATUS = {
  1: { name: 'Общий критерий', nameInMultiAnswers: 'statusCommon' },
  2: { name: 'Оценка на этапе', nameInMultiAnswers: 'statusOnStage' },
}
